import { IWeekWorkTime } from 'features/working-hours-picker/interfaces/time-table-input.interface';

export const WEEKEND_RU = 'Выходной';
export const ALL_DAY_RU = '24 часа';
export const WORKING_TIME_WEEK_TITLES = ['Рабочее время', 'Выходной', '24 ч.'];
export const WEEKEND_DEFAULT_TIME_RANGE = [null, null];
export const ALL_DAY_TIME_RANGE = ['00:00', '00:00'];
export const ALL_DAY_TIME_RANGE_RULES = ['00:00', '23:59'];
export const DEFAULT_TIME_RANGE = ['09:00', '20:00'];
export const WORK_TIME_OPTIONS = ['Каждый день', 'Неделя'];
export const EMPLOYEE_BASED_OPTION = 'По графикам сотрудников';
export const AROUND_THE_CLOCK = 'Круглосуточно';
export const DEFAULT_TIME_TABLE: IWeekWorkTime = {
  monday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
  tuesday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
  wednesday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
  thursday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
  friday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
  saturday: {
    start: DEFAULT_TIME_RANGE[0],
    end: DEFAULT_TIME_RANGE[1],
  },
  sunday: { start: DEFAULT_TIME_RANGE[0], end: DEFAULT_TIME_RANGE[1] },
};
export const DEFAULT_TIME_DAY = {
  start: DEFAULT_TIME_RANGE[0],
  end: DEFAULT_TIME_RANGE[1],
};
export const ALL_DAY_EVERY_DAY = {
  start: ALL_DAY_TIME_RANGE[0],
  end: ALL_DAY_TIME_RANGE[1],
};
